import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
    backgroundColor: '#ffffff'
    },
    section: {
    margin: 20,
    padding: 10,
    flexGrow: 1
    },
    company_name: {
        Font:'Arial',
        fontWeight:500,
        fontSize:9
    },
    computationsText: {
        Font:'Arial',
        fontWeight:900,
        fontSize:10
    },

    package: {
        Font:'Arial',
        fontWeight:900,
        fontSize:9,
        width:100
    },
    company_adress: {
        Font:'Arial',
        fontWeight:700,
        fontSize:9
    },
    padding:{
        padding:1
    },
    paddingTop10:{
        paddingTop:13
    },
    cell: {
        marginRight:10,

    },
    cellRight: {
        textAlign:"right"
   
    },
    cellLeft: {
        textAlign:"left"
       
    },
    tableRow:{
        display: 'flex',
        flexDirection: 'row',

    },
    col1:{
        display: 'flex',
        flexDirection: 'row',
        width:150
    },

    paymentInfoText:{
        Font:'Roboto',
        fontWeight:500,
        fontSize:10
    },

    paymentInfoCol:{
        display:'flex',
        flexDirection:'row',
        width:100,
        maxWidth:100
    },

    rowWidth:{
        width:'100%'
    },
    col50:{
        width:'50%'
    },
    col45:{
        width:'45%'
    },
    col2:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col3:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col4:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    col5:{
        display: 'flex',
        flexDirection: 'row',
        width:100
    },
    floatright:{
        alignItems:"flex-end"
    },
    colComputations1:{
        width:100
    },
    colComputations2:{
        width:100
    },
    row:{
        display: 'flex',
        flexDirection: 'row',
    },
    textcenter:{
        textAlign:"center"
    },
    textleft:{
        textAlign:"left"
    },
    textRight:{
        textAlign:"right"
    },
    border:{
        borderBottom:1,
    },
    borderAll:{
        border:1
    },
    borderTop:{
        borderTop:1,
    },
    boldFont:{
        fontWeight:980,
    },
    fontSize11:{
        fontSize:11,
        fontWeight:800,
    },
    textCenter:{
        alignItems:'center'
    },
    alignCenter:{
        display: 'flex',
        flexDirection: 'row',
    },
    marginRight10:{
        marginRight:'10%'
    },
    paddingLeft:{
        paddingLeft:450
    },
    marginTopt10:{
        paddingTop:'4%'
    },
    pageNumbers: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize:6
    },
        col400:{
        display: 'flex',
        flexDirection: 'row',
         width:'82%'
    },
});

export function PdfDocument(props) {
    console.log('props',props);
    var duplicatePrint = [0,1];
    return (
        <Document>
            <Page size="Letter" style={styles.page} orientation="portrait" wrap={false}>


                    <View style={styles.section}>
                        {/* HEADER SECTION DUBAI */}
                               
                        <View style={styles.textCenter}>
                                <Text style={styles.fontSize11}>Wholesale Set</Text>
                            </View>
                        {!props.headers.TRN == "" ? 
                            <View>
                                <Text style={styles.company_name}>TAX INVOICE</Text>
                                <Text style={styles.company_adress}>JCP Premiere General Trading LLC</Text>
                                <Text style={styles.company_adress}>TRN: {props.headers?.TRN ?? ''}</Text>
                                <Text style={[styles.company_name, styles.paddingTop10]}>Invoice No.: {props.headers?.invoice_no?? ''}</Text>
                            </View>
                        : null} 
                        {/* HEADER SECTION */}
                        <Text style={styles.company_name}>{props.headers.companyname}</Text>
                        {/* Address */}
                        <Text style={styles.company_adress}>{props.headers.companyaddress}</Text>
                        {/* Contact No. and Website */}
                        <Text style={styles.company_adress}>{props.headers.companyphone +" | "+ props.headers.companywebsite}</Text>

                        {/* Activation No. */}
                        {!props.headers.idno == "" ? 
                            <Text style={styles.company_name}>ID No: {props.headers.idno}</Text>
                        : null}
                        {/* Pin No. */}
                        {!props.headers.pinno == "" ? 
                            <Text style={styles.company_name}>PIN No.: {props.headers.pinno}</Text>
                        : null} 
                        {/* Act No. */}
                        {!props.headers.actno == "" ? 
                            <Text style={styles.company_name}> Activation No.: {props.headers.actno}</Text>
                        : null} 

                        {/* Package Sales Information */}

                        <View>
                                <Text style={[styles.fontSize11,styles.paddingTop10,{fontFamily:'Helvetica-Bold',}]}>Transaction Information</Text>
                            </View>
                        {/* Atype */}
                        {/* <Text style={[styles.company_name, styles.paddingTop10]}>Type:{props.headers.transactiontype}</Text> */}
                        {/* Date */}
                        <Text style={[styles.company_name,styles.rowWidth]}>Date:{props.headers.date}</Text>
                        {/* Sold To */}
                        <Text style={[styles.company_name,styles.rowWidth]}>Sold To:{props.headers.soldto}</Text>
                        {/* Package */}
                        {/* <Text style={[styles.package,styles.rowWidth]}>Package:{props.headers.package}</Text> */}
                        <Text style={[styles.package,styles.rowWidth]}>Account Type:{props.otherInfo.packagetype}</Text>
                        <Text style={[styles.package,styles.rowWidth]}>Account Type Name:{props.otherInfo.packagetypename}</Text>
                        {/* Reference No. */}
                        <Text style={[styles.company_name,styles.rowWidth]}>Reference No.:{props.headers.refno}</Text>
                        {/* Location */}
                        <Text style={[styles.company_name,styles.rowWidth]}>Location:{props.headers.location}</Text>
                        {/* <Text style={[styles.company_name,styles.rowWidth]}>Total Set:{props.totalSetCount}</Text> */}
                        {/* Set Details */}
                        <View style={[styles.tableRow,styles.paddingTop10,styles.border]}>
                            <View style={[styles.tableRow,styles.col400,styles.cellLeft]}>
                                <Text style={[styles.company_adress,styles.cellLeft,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Set Name</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col2,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Qty</Text>
                            </View>
                        </View>

                    {props.packages.length > 0 ? 
                            props.packages.map((row, ind) => 
                                    <View  key={ind} style={[styles.tableRow,styles.border]}>
                                    <View style={[styles.tableRow,styles.col400]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding]}>{row[0]}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col2]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{row[1]}</Text>
                                    </View>
                                </View>
                            )
                        : null}
                                    <View style={[styles.tableRow,{width:"100%"}]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding,{textAlign:'right'}]}>Total: {props.totalSetCount}</Text>
                                    </View> 

                        {/* Item Details */}
                        <View style={[styles.tableRow,styles.paddingTop10,styles.border]}>
                            <View style={[styles.tableRow,styles.col1,styles.cellLeft]}>
                                <Text style={[styles.company_adress,styles.cellLeft,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Description</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col2,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Qty</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col3,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Unit</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col4,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Price</Text>
                            </View>
                            <View style={[styles.tableRow,styles.col5,styles.cellRight]}>
                                <Text style={[styles.company_adress,styles.cellRight,styles.boldFont,{fontFamily:'Helvetica-Bold',}]}>Total</Text>
                            </View>
                        </View>
                        {!props.items == "" ? 
                            props.items.map((row, ind) => 
                                <View key={ind} style={[styles.tableRow,styles.border]}>
                                    <View style={[styles.tableRow,styles.col1]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding]}>{props.items[ind].description}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col2]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{Math.abs(props.items[ind].qty)}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col3]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].unit}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col4]}>
                                        <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].price}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.col5]}>
                                        <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.items[ind].total}</Text>
                                    </View>
                                </View>
                            )
                        : null} 

                        {/* Computations */}

                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                                <View style={[styles.col50]}>
                                </View>
                                <View style={[styles.col50,styles.floatright]}>
                                      <Text style={[styles.computationsText]}>Total Amount:  {props.computations.total_amount}</Text> 
                                </View>
                        </View>
                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                              <View style={[styles.col50]}>
                                </View>
                                <View style={[styles.col50,styles.floatright]}>
                                      <Text style={[styles.computationsText]}>Shipping/Freight:  {props.computations.shippingfreight}</Text> 
                                </View>
                        </View>
 

                        {!props.computations.discount == "" ?
                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                            <View style={[styles.col50]}>
                            </View>
                            <View style={[styles.col50,styles.floatright]}>
                                    <Text style={[styles.computationsText]}>Discount:  {props.computations.discount}</Text> 
                            </View>
                        </View> 
                        : null} 
                        {!props.computations.netamount == "" ?
                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                            <View style={[styles.col50]}>
                            </View>
                            <View style={[styles.col50,styles.floatright]}>
                                    <Text style={[styles.computationsText]}>Net Amount:  {props.computations.netamount}</Text> 
                            </View>
                        </View> 
                        : null}
                        {!props.computations.vatamount == "" ?
                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                            <View style={[styles.col50]}>
                            </View>
                            <View style={[styles.col50,styles.floatright]}>
                                    <Text style={[styles.computationsText]}>VAT Amount:  {props.computations.vatamount}</Text> 
                            </View>
                        </View> 

                        : null}
                        <View style={[styles.rowWidth,styles.border,styles.alignCenter]}>
                            <View style={[styles.col50]}>
                            </View>
                            <View style={[styles.col50,styles.floatright]}>
                                 <Text style={[styles.computationsText]}>Grand Total:  {props.computations.grandtotal}</Text> 
                            </View>
                        </View> 


                             <View>
                                <Text style={[styles.fontSize11,styles.marginTopt10,{fontFamily:'Helvetica-Bold',}]}>Payment Information</Text>
                            </View>

                        <View style={[styles.tableRow,styles.paddingTop10]}>
                            <View style={[styles.tableRow,styles.paymentInfoCol,styles.cellLeft,styles.paymentInfoText]}>
                                <Text style={[styles.company_adress,styles.cellLeft]}>Type</Text>
                            </View>
                            <View style={[styles.tableRow,styles.paymentInfoCol,styles.cellLeft,styles.paymentInfoText]}>
                                <Text style={[styles.company_adress]}>Reference</Text>
                            </View>
                            <View style={[styles.tableRow,styles.paymentInfoCol,styles.paymentInfoText]}>
                                <Text style={[styles.company_adress,styles.cellRight]}>Amount</Text>
                            </View>
                        </View>
                        {!props.payment == "" ? 
                            props.payment.map((row, ind) => 
                                <View  key={ind} style={[styles.tableRow]}>
                                    <View style={[styles.tableRow,styles.paymentInfoCol]}>
                                        <Text style={[styles.company_adress,styles.cellLeft,styles.padding]}>{props.payment[ind].paymentid}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.paymentInfoCol,styles.cellLeft]}>
                                    <Text style={[styles.company_adress,styles.padding]}>{props.payment[ind].refno}</Text>
                                    </View>
                                    <View style={[styles.tableRow,styles.paymentInfoCol]}>
                                    <Text style={[styles.company_adress,styles.cellRight,styles.padding]}>{props.payment[ind].amount}</Text>
                                    </View>
                                </View>
                            )
                        : null} 
 
                        {/* Signature */}
                        <View style={[styles.rowWidth,styles.marginTopt10]}>
                            <View style={[styles.alignCenter]}>
                                <View style={[styles.borderTop,styles.col45,styles.marginRight10]}>
                                    <Text style={[styles.company_name,styles.col45]}>Received By:</Text> 
                                </View>
                                <View style={[styles.col45]}>
                                    <Text style={[styles.company_name,styles.rowWidth,styles.floatright]}>I hereby certify that I receive the items in good condition and complete quantity.</Text>
                                </View>
                            </View>
                        </View>

                        <View style={[styles.rowWidth,styles.paddingTop10]}>
                            <View style={[styles.alignCenter]}>
                                <View style={[styles.borderTop,styles.col45,styles.marginRight10]}>
                                    <Text style={[styles.company_name,styles.col45]}>Prepared By:</Text> 
                                </View>
                                <View style={[styles.col45,styles.borderTop]}>
                                      <Text style={[styles.company_name,styles.floatright]}>Checked By:</Text> 
                                </View>
                            </View>
                        </View>

                        <View style={[styles.rowWidth,styles.paddingTop10]}>
                            <View style={[styles.alignCenter]}>
                                <View style={[styles.borderTop,styles.col45,styles.marginRight10]}>
                                    <Text style={[styles.company_name,styles.col45]}>Released By:</Text> 
                                </View>
                                <View style={[styles.col45,styles.borderTop]}>
                                    <Text style={[styles.company_name,styles.col45,styles.floatright]}>Received Date:</Text> 
                                </View>
                            </View>
                        </View>

                        <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
                            `Page ${pageNumber} | ${props.headers.trandate} - ${props.headers.trantime}`
                        )} />
                    </View>
      
            </Page>
        </Document>
    );
};